import { Search } from '@vtex/admin-ui';
import { useSearchBar } from './use-search-bar.hook';

export type SearchBarProps = {
  onSearch: (debouncedValue: string) => void;
};

export const SearchBar = (props: SearchBarProps) => {
  const { search } = useSearchBar({ ...props });

  return <Search id="search" {...search.getInputProps()} />;
};
